export class FileUtil {

    constructor() {

    }

    static fileToBlob(file: File): Promise<Blob> {
        return new Promise((resolve, reject) => {

            let reader = new FileReader();
            reader.onload = (e: any) => {
                let blob = new Blob([new Uint8Array(e.target.result)], { type: file.type });
                resolve(blob);
            };
            reader.readAsArrayBuffer(file);

        });
    }
}